import { Outlet, useNavigate } from "react-router-dom";
import {
  ClerkProvider,
} from "@clerk/clerk-react";
import React from "react";
import "../styles/Navbar.css";
import GlobalErrorProvider from "../components/common/GlobalErrorProvider";

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_FRONTEND_API;

if (!PUBLISHABLE_KEY) {
  throw new Error("Missing Publishable Key");
}

export default function RootLayout() {
  const navigate = useNavigate();

  return (
    <ClerkProvider
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
      publishableKey={PUBLISHABLE_KEY}
    >
      <GlobalErrorProvider>
        <Outlet />
      </GlobalErrorProvider>
    </ClerkProvider>
  );
}